var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-content"},[_c('page-section',{attrs:{"title":"Mentions légales"}},[_c('div',{staticClass:"container-cap"},_vm._l((_vm.content),function(section,k){return _c('div',{key:`section-${k}`},[_c('h2',[_vm._v(_vm._s(section.title))]),_c('span',{domProps:{"innerHTML":_vm._s(section.text)}})])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }